import { render, staticRenderFns } from "./AppExternalLink.vue?vue&type=template&id=63733fe4&"
import script from "./AppExternalLink.vue?vue&type=script&lang=js&"
export * from "./AppExternalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports